// extracted by mini-css-extract-plugin
export default {"title":"AgentView_title__Zr+eJ","header":"AgentView_header__Qr5Tg"};